var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWork = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,7H18V4c0-0.5-0.4-1-1-1H7C6.4,3,6,3.4,6,4v3H3c-0.5,0-1,0.4-1,1V20c0,0.5,0.4,1,1,1H21c0.5,0,1-0.4,1-1V7.9 C22,7.4,21.6,7,21,7z M8,5h8v2H8V5z M4,9h5.5v2.3h5.1V9H20v10H4V9z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWork, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/work.65c98ef6.svg";
export { ForwardRef as ReactComponent };